module.exports = __webpack_public_path__ + "static/media/img_group_8751.b31d0a41.svg";